import { IRoleDTO, IUserDTO, PaginationDTO, UserDTO } from '@/dtos';
import { getAllUsersByRoleAPI } from '@/services/admin';
import { useQuery } from '@tanstack/vue-query';
import { defineStore } from 'pinia';
import { computed, Ref } from 'vue';
import { useAuthStore } from '../auth';

export const useAdminUserStore = defineStore('admin-user', () => {
  const authStore = useAuthStore();

  const getAllUsersByRoleQuery = (
    role: Ref<IRoleDTO>,
    exclude: Ref<string[]>,
    pagination: Ref<PaginationDTO>,
  ) =>
    useQuery({
      queryKey: computed(() => ['users', role.value, pagination.value]),
      queryFn: async (): Promise<{ data: IUserDTO[]; count: number }> => {
        const ret = await getAllUsersByRoleAPI(role.value, exclude.value, pagination.value);
        const users = await Promise.all<IUserDTO[]>(ret.data.map((user) => new UserDTO(user)));
        return { data: users, count: ret.count };
      },
      enabled: computed(() => !!authStore.isAdmin),
    });

  return {
    getAllUsersByRoleQuery,
  };
});
